export const sizing = {
  axisLabel: '{axis} ({value} jednostki)',
  overwriteLength: 'Zmieniaj długość wraz ze skalą X',
  overwriteScaleX: 'Zmieniaj skalę X wraz z długością',
  overwriteHeight: 'Zmieniaj wysokość wraz ze skalą Y',
  overwriteScaleY: 'Zmieniaj skalę Y wraz z wysokością',
  overwrtiteWidth: 'Zmieniaj szerokość wraz ze skalą Z',
  overwriteScaleZ: 'Zmieniaj skalę Z wraz z szerokością',
  sceneResizeRequired:
    'Edycja skali i wymiarów jest zablokowana. Zmień wielkość sceny, jeśli obiekt jest zbyt mały lub zbyt duży.',
} as const
